import mixpanel from 'mixpanel-browser'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { DrawerProvider } from './context/DrawerContext'
import './index.css'

const debug = import.meta.env.VITE_NODE_ENV === 'local'

const MIXPANEL_TOKEN = '23ca402dca3d567f2b6d1249ea2aec95'
mixpanel.init(MIXPANEL_TOKEN, {
  debug,
  autocapture: {
    pageview: 'full-url',
    click: true,
    input: true,
    scroll: true,
    submit: true,
    capture_text_content: true,
    allow_selectors: ['button', 'a', '.conversation-card'],
  },
})

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <DrawerProvider>
      <App />
    </DrawerProvider>
  </React.StrictMode>,
)
